import Base from './base'
import Vue from 'vue'
import { Message } from 'element-ui'

class Notice extends Base {
  constructor () {
    super('Notice')
  }

  /**
   * 获取告警通知
   * @param {Object} data
   * @param {String} data.zoneId 区域id
   * @param {String} data.page 当前页
   * @param {String} data.perPage 截取数量
   * @param {String} data.deviceType 设备类型
   * @param {String} data.type 0：异常 1：通知
   */
  async getNotice (data) {
    let params = Object.assign({}, {
      zoneId: '',
      page: '',
      perPage: '',
      deviceType: 'aircon',
      type: ''
    }, data)
    const result = await Vue.axios.get(`${Vue._config.ds}/devices/alarmNotices`, { params })
    // 处理必要的错误提示和数据兜底
    if (result.data.code !== 1) {
      Message.error('消息数据获取失败，稍后重试！')
      result.data.data = {
        total: 0,
        data: []
      }
    }
    return result.data.data
  }
  /**
   * 已读告警通知更新接口
   * @param {Object} data
   * @param {String} data.zoneId 区域id (全部标注已读时使用)
   * @param {String} data.noticeId 当前已读的id
   * @param {String} data.type 0：异常 1：通知
   */
  async markedRead (data) {
    let params = {
      zoneId: '',
      noticeId: '',
      type: ''
    }
    params = Object.assign({}, params, data)
    const result = await Vue.axios.put(`${Vue._config.ds}/devices/readAlarmNotices`, params)
    // 处理必要的错误提示和数据兜底
    if (result.data.code !== 1) {
      Message.error('设置失败，稍后重试！')
    }
    return result.data
  }
  /**
   * 清除区域告警通知更新接口
   * @param {Object} data
   * @param {String} data.zoneId 区域id
   * @param {String} data.type 0：异常 1：通知
   */
  async remove (data) {
    const result = await Vue.axios.put(`${Vue._config.ds}/devices/clearAlarmNotices`, data)
    // 处理必要的错误提示和数据兜底
    if (result.data.code !== 1) {
      Message.error('设置失败，稍后重试！')
    }
    return result.data
  }
  /**
   * 获取告警通知未读记录数
   * @param {Object} data
   * @param {String} data.zoneId 区域id
   */
  async unReadTotal (data) {
    let params = {
      zoneId: ''
    }
    params = Object.assign({}, params, data)
    const result = await Vue.axios.get(`${Vue._config.ds}/devices/getAlarmNoticeTotal`, { params })
    // 处理必要的错误提示和数据兜底
    if (result.data.code !== 1) {
      Message.error('获取未读通知失败！')
      result.data.data = 0
    }
    return result.data.data
  }
}

export default new Notice()
